import React from "react";
import {
  DEFAULT_SLOT_INTERVAL,
  ORDER_PHASE_CONTACTING,
  ORDER_PHASE_DELIVERING,
  ORDER_TYPE_DELIVERY
} from "../../../constants";
import { formatEstimationTime, getEstimationTime } from "../../../utils";
import { Box, Typography } from "@mui/material";
import { getIcon } from "@dishopsaas/design-system";
import getStyles from "../OrderStatus.styles";
import { ICONS } from "../../../constants/utils";
import moment from 'moment';
import { DATE_FORMAT } from '../../../constants/date';
import { useAppSelector } from "../../../redux/hook";
type OrderStatusEstimationTimeProps = {
  order: any;
  isMobile?: boolean
};

const InfoRow = ({
  icon,
  children,
}: {
  icon: string;
  children: React.ReactNode;
}) => (
  <Box sx={getStyles().rowSx}>
    {getIcon(icon, { size: 12 })}
    {children}
  </Box>
);

export default function OrderStatusEstimationTime({
  order,
  isMobile
}: OrderStatusEstimationTimeProps) {
  if (!order) return null;
  const styles = getStyles()
  const { status, orderType, validationCode, date,
    datePreparationEnded,
    estimatedDeliveryDate } = order;
  const { configHours } = useAppSelector((state) => state.configurationReducer);
  const shouldDisplayValidationCode =
    status === ORDER_PHASE_DELIVERING && validationCode;
  const slotInterval = configHours?.slotInterval
  const estimationTime = getEstimationTime(order);
  const { estimationDayFormat } =
    formatEstimationTime(estimationTime);

  const label = status === ORDER_PHASE_CONTACTING ? 'Créneau choisi :' : `  ${orderType === ORDER_TYPE_DELIVERY
    ? 'Livraison'
    : `heure de récupération`}
      ${isMobile ? 'prévue' : 'prévue pour :'} `
  const slot = `${moment(date).format(DATE_FORMAT.TIME)} - ${moment(date)
    .add(slotInterval ?? DEFAULT_SLOT_INTERVAL, 'minutes')
    .format(DATE_FORMAT.TIME)}`;

  const time =
    status === ORDER_PHASE_CONTACTING
      ? `${moment().isSame(moment(date), 'day') ? '' : `${estimationDayFormat} `}${slot}`
      : `${isMobile ? '' : estimationDayFormat} à ${moment(
        estimatedDeliveryDate ?? datePreparationEnded
      ).format(DATE_FORMAT.TIME)}`;

  return (
    <Box sx={styles.containerSx}>
      <Box sx={styles.columnSx}>
        <Typography variant="subtitle1">{label}</Typography>

        <InfoRow icon={ICONS.Clock}>
          <Typography variant="h5">
            {time}
          </Typography>
        </InfoRow>
      </Box>
      {shouldDisplayValidationCode && (
        <Box sx={styles.columnSx}>
          <InfoRow icon={ICONS.Info}>
            <Typography variant="subtitle1">Code livreur</Typography>
          </InfoRow>

          <InfoRow icon={ICONS.Lock}>
            <Typography variant="h5">{validationCode}</Typography>
          </InfoRow>
        </Box>
      )}
    </Box>
  );
}
